<template>
  <div class="mobile-header" :class="{ 'mobile-header-active': active }">
    <img
      class="logo"
      src="../../assets/img/logo_small.svg"
      alt="KCM"
      @click="goTo('/')"
    />
    <div class="lang-div" @click="changeLang()">
      <a>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="15.631"
          viewBox="0 0 30 15.631"
        >
          <g id="flat-world-map" transform="translate(0 -9.781)">
            <g
              id="Group_1192"
              data-name="Group 1192"
              transform="translate(0 9.782)"
            >
              <path
                id="Path_4324"
                data-name="Path 4324"
                d="M9.984,19.659l1.234.6L10.513,21.7l-.706.107-.107.566L8.254,23.611l-.67,1.269.493.53L7.268,25.2l-.284-.706.811-3.28-.671-.6-.315-1.269.379-.621-.346.052-.492-.633-.424-.212-.987-.353-.812-1.269-.493-.917V14.156l-.811-1.375L1.8,12.146l-.635.353L0,13.064l.74-.6-.459-.107-.174-.6.528-.424-.528-.07.1-.388H.6l-.353-.53L1.2,9.782l1.728.954.637-.6,1.374.811,2.645-.284V12l-1.058.211-.212.566,1.023,1.092.247-.035.175-1.375.673-.035.28.774.353-.211.776,1.73-1.093.491-.846.46-.67.918v.459l-.248.035-.175-.494-.953.14-.212.6.246.353.352-.284.353.035-.176.5.422.03.142.528.285.095.21-.343,1.411.141.951.706Zm16.708-.314-.076.6-.506-.185.093-.322-.555-.046-.719.67-.763.277.185,1.037-.071.208.28.161,1.132-.28.439.256.208-.115.138.418.577.163.417-.256.23-1.244-.627-.625Zm-2.8-.58.6.115.278-.854-.163-.14-.809.509Zm1.847-.233.624.648.358.024.151-.138.508.322-.208-.439-.948-.461Zm1.133-5.246h-.162l-.023.832L26.268,15l-.532.392-.023.347.97-.577.046-.6.322-.3-.253-.206.138-.487Zm2.5,8.391.069.646-.716.671.462.046.414-.626.323-.438-.208-.023ZM13.912,11.949v.674l.468-.2.132-.206-.506-.974-.3.208.018.26-.281.339-.019.354h.338Zm4.228,7.93-.018.75.3.131.3-.9-.076-.376Zm10.394-7.843.023.533-.6.74-.023-.833.785-.948-.483.071-.626.508-.764-.046-.577.555.415.3L26.2,14.256l-.415.071-.256.369.115.486-.3.16L25.25,14.9l-.256-.348-.347.368.277.785-.392.718-.857.046-.184.3.392.577-.415.347-.426-.443-.015.417.372.417.162.739.464.165.626.254L23.5,19.042l-.486-.462-.438-.626.6.3-.277-.506-.057-.691-.264.067-.323-.692-.9.625v.4l-.324.322-.414-1.04-.461-.555-1.111-.208-.322-.275-.163.092.23.555.369-.185.486.37-1.432.855-.742-1.456-.155.027.756,1.729.74-.347-.23.81-.74.668.115.995-.416.322-.76,1.433-.764.139-.67-1.618.163-.739-.417-1.3-1.41.092-.787-.763.14-1.248.763-.925,1.479-.254.093.392.6.392.23-.322.918.235.237-.143.105-.345-.634-.107-.2-.354-.149-.076-.131.449-.283-.356.018-.3-.378-.3-.224-.112.019.3.469.318-.244.282-.336-.45-.243-.282-.562.282-.393.618-.6-.093-.037-.749.766.054-.242-.391-.151-.32.58-.188.318-.429.262-.02-.057-.242.168-.226.131.374.729.018.2-.525.283.095-.095-.355.435-.139-.135-.16-.394.11-.138-.336-.017,0,.012-.024-.057-.141.158-.112.138-.352L16.3,10.9l-.244.3-.2.447.227.242-.227.6-.337.131-.186-.6-.394.225-.187-.112.018-.58.338-.26.281-.693.712-.392,1.776.326c2.049-.215,5.767-.61,5.767-.61l6.134.866L30,11.44l-.834.464ZM18.012,14.379l-.973-.505-.3.524.131.242.563-.093.412.112Zm1.027.635-.091-.58-.189-.281.227-.094v-.28l-.581.318.2.524-.092.355Zm-8.381-4.546-.521-.143-.644.688.828,2.156.392.1.031-.7.265-.163.015-.266.273-.513-.191-.387Z"
                transform="translate(0 -9.782)"
                fill="#fff"
              ></path>
            </g>
          </g>
        </svg>
        {{ $i18n.locale === "bg" ? "EN" : "BG" }}
      </a>
    </div>
    <div
      class="nav-mobile-toggle"
      :class="{ 'nav-mobile-toggle-active': active }"
      @click="active = !active"
    >
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <section class="links-and-socials">
      <transition name="scaleY">
        <ul class="mobile-header-nav" v-if="active">
          <li>
            <p @click="goTo('/about')">{{ $t("nav1") }}</p>
            <router-link to="/about">{{ $t("nav1-1") }}</router-link>
            <router-link to="/about?page=history">{{
              $t("nav1-2")
            }}</router-link>
            <router-link to="/about?page=mission">{{
              $t("nav1-3")
            }}</router-link>
          </li>
          <li>
            <p @click="goTo('/kcm-group')">{{ $t("nav2") }}</p>
            <router-link to="/kcm-group">{{ $t("nav2-1") }}</router-link>
            <router-link to="/kcm-group?page=executive">{{
              $t("nav2-2")
            }}</router-link>
            <router-link to="/kcm-group?page=companies">{{
              $t("nav2-3")
            }}</router-link>
          </li>
          <li>
            <p @click="goTo('/products')">{{ $t("nav3") }}</p>
            <router-link to="/products">{{ $t("nav3-1") }}</router-link>
            <router-link to="/products?page=zn">{{ $t("nav3-2") }}</router-link>
            <router-link to="/products?page=pb">{{ $t("nav3-3") }}</router-link>
            <router-link to="/products?page=au">{{ $t("nav3-4") }}</router-link>
            <router-link to="/products?page=ag">{{ $t("nav3-5") }}</router-link>
            <router-link to="/products?page=ch">{{ $t("nav3-6") }}</router-link>
          </li>
          <li>
            <p @click="goTo('/sustainability')">{{ $t("nav4") }}</p>
            <router-link to="/sustainability">{{ $t("nav4-1") }}</router-link>
            <router-link to="/sustainability?page=environment">{{
              $t("nav4-2")
            }}</router-link>
            <router-link to="/sustainability?page=health-and-safety">{{
              $t("nav4-3")
            }}</router-link>
            <router-link to="/sustainability?page=social-responsibility">{{
              $t("nav4-4")
            }}</router-link>
            <router-link to="/sustainability?page=gdpr">{{
              $t("nav4-5")
            }}</router-link>
            <router-link to="/sustainability?page=reporting">{{
              $t("nav4-6")
            }}</router-link>
          </li>
          <li>
            <p @click="goTo('/careers')">{{ $t("nav5") }}</p>
            <router-link to="/careers">{{ $t("nav5-1") }}</router-link>
            <router-link to="/careers?page=internships">{{
              $t("nav5-2")
            }}</router-link>
            <router-link to="/careers?page=events">{{
              $t("nav5-3")
            }}</router-link>
            <router-link to="/careers?page=jobs">{{
              $t("nav5-4")
            }}</router-link>
            <router-link to="/careers?page=application">{{
              $t("nav5-5")
            }}</router-link>
          </li>
          <li>
            <p @click="goTo('/news')">{{ $t("nav6") }}</p>
            <router-link to="/news">{{ $t("nav6-1") }}</router-link>
            <router-link to="/news?type=media">{{ $t("nav6-2") }}</router-link>
            <router-link to="/news?type=kcm-today">{{
              $t("nav6-4")
            }}</router-link>
          </li>
          <li>
            <p @click="goTo('/contacts')">{{ $t("nav7") }}</p>
            <router-link to="/contacts">{{ $t("nav7") }}</router-link>
          </li>
          <li>
            <p @click="goTo('/life-recad')" class="liferecad">
              <img src="@/assets/img/liferecad_logo-bg.svg" alt="Life Recad" />
              <span>{{ $t("nav8") }}</span>
            </p>
            <router-link to="/life-recad">{{ $t("nav8-1") }}</router-link>
            <router-link to="/life-recad?page=documents">{{ $t("nav8-2") }}</router-link>
            <router-link to="/life-recad?page=news">{{ $t("nav8-3") }}</router-link>
            <router-link to="/life-recad?page=contacts">{{ $t("nav8-4") }}</router-link>
          </li>
        </ul>
      </transition>
      <transition name="fade">
        <div class="socials-div" v-if="active">
          <a
            href="https://youtube.com/playlist?list=PL70aEbI637XAx3-NeLqI6T0XGK4qOahQi"
            target="_blank"
          >
            <img src="@/assets/img/yt.svg" alt="" />
          </a>
          <a
            href="https://www.facebook.com/people/%D0%A5%D0%BE%D0%BB%D0%B4%D0%B8%D0%BD%D0%B3-%D0%9A%D0%A6%D0%9C-2000/100057096234380/"
            target="_blank"
          >
            <img src="@/assets/img/fb.svg" alt="" />
          </a>
          <a href="https://www.linkedin.com/company/kcm-ad/" target="_blank">
            <img src="@/assets/img/in.svg" alt="" />
          </a>
        </div>
      </transition>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: false,
    };
  },
  watch: {
    $route() {
      this.active = false;
    },
  },
  methods: {
    goTo(url) {
      this.$router.push(url);
      this.active = false;
    },
    saveLang() {
      localStorage.setItem("lang", this.$i18n.locale);
    },
    changeLang() {
      if (this.$i18n.locale === "bg") {
        this.$i18n.locale = "en";
      } else {
        this.$i18n.locale = "bg";
      }
      this.saveLang();
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-header {
  display: none;
}

@media screen and (max-width: 1280px) {
  .mobile-header {
    align-items: center;
    background-color: $mainColor;
    display: flex;
    justify-content: space-between;
    height: 48px;
    left: 40px;
    top: 10px;
    padding: 0 20px;
    position: fixed;
    @include transition(all 1s $mainCubic);
    width: calc(100% - 80px);
    z-index: 10;
  }

  .logo {
    height: 28px;
    left: 20px;
    position: absolute;
    @include transform(translateY(-50%));
    @include transition(all 1s $mainCubic);
    top: 24px;
  }

  .links-and-socials {
    display: flex;
    flex-direction: column;
    height: 100%;

    .socials-div {
      align-items: flex-end;
      display: flex;
      gap: 10px;
      justify-content: center;
      padding: 10px;
      @include transition(all 1s $mainCubic);
    }
  }

  .lang-div {
    align-items: center;
    display: flex;
    height: 28px;
    margin-left: auto;
    opacity: 0;
    position: absolute;
    right: 58px;
    top: 30px;
    @include transform(translateY(-50%));
    @include transition(all 1s $mainCubic);
    width: 60px;

    a {
      align-items: center;
      color: #fff;
      font-size: 11px;
      display: flex;
    }

    svg {
      display: inline-block;
      margin-right: 5px;

      path {
        @include transition(all 1s);
        fill: #fff;
      }
    }
  }

  .nav-mobile-toggle {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 26px;
    justify-content: center;
    position: absolute;
    right: 20px;
    top: 24px;
    @include transform(translateY(-50%));
    @include transition(all 1s $mainCubic);
    width: 28px;
    z-index: 10;

    span {
      background-color: #fff;
      display: block;
      height: 2px;
      margin-bottom: 2px;
      width: 100%;
      @include transition(all 1s $mainCubic);
    }

    span:nth-child(2) {
      width: 45%;
      transition-delay: 0.2s;
    }

    span:nth-child(3) {
      width: 75%;
      transition-delay: 0.3s;
    }

    span:nth-child(4) {
      width: 50%;
      transition-delay: 0.4s;
    }

    span:nth-child(5) {
      width: 80%;
      transition-delay: 0.5s;
    }

    span:nth-child(6) {
      width: 90%;
      margin: 0;
    }
  }

  .nav-mobile-toggle-active {
    span:nth-child(1) {
      @include transform(rotate(45deg) translateY(7px) translateX(7px));
      margin-right: -20px;
    }

    span:nth-child(2),
    span:nth-child(3),
    span:nth-child(4),
    span:nth-child(5) {
      @include transform(translateX(1000px));
    }

    span:nth-child(6) {
      @include transform(rotate(315deg) translateY(-7px) translateX(7px));
      margin-right: -20px;
      width: 100%;
    }
  }

  .mobile-header-nav {
    display: flex;
    flex-direction: column;
    height: 100%;
    // justify-content: center;
    overflow: auto;
    width: 100%;

    p {
      align-items: center;
      background-color: #fff;
      color: $mainColor;
      font-size: 18px;
      font-weight: 500;
      display: flex;
      justify-content: flex-end;
      height: 30px;
      line-height: 22px;
      margin: 10px 0;
      padding: 0 10px;
      text-align: right;
      text-transform: uppercase;
      width: 100%;

      &.liferecad {
        display: flex;
        justify-content: space-between;
        img {
          height: 80%;
        }
      }
    }

    li {
      display: flex;
      flex-wrap: wrap;
    }

    a {
      font-size: 14px;
      font-weight: 300;
      display: block;
      color: #fff;
      margin: 5px 0;
      width: 50%;
    }

    a:nth-of-type(2n) {
      text-align: right;
    }
  }

  .mobile-header-active {
    height: 100%;
    left: 60%;
    top: 0;
    padding: 60px 20px 0;
    width: 40%;

    // .links-and-socials {
    //   .socials-div {
    //     opacity: 1;
    //   }
    // }

    .logo,
    .nav-mobile-toggle {
      top: 30px;
    }

    .lang-div {
      opacity: 1;
    }
  }
}

@media screen and (max-width: 1000px) {
  .mobile-header-active {
    left: 40%;
    width: 60%;
  }
}

@media screen and (max-width: 800px) {
  .mobile-header-active {
    left: 0%;
    width: 100%;
  }
}

@media screen and (max-width: 600px) {
  .mobile-header {
    left: 20px;
    width: calc(100% - 40px);
  }

  .mobile-header-active {
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
  }
}

@media screen and (max-width: 420px) {
  .mobile-header-nav {
    p {
      font-size: 13px;
      height: 24px;
      line-height: 22px;
      margin: 10px 0;
    }

    a {
      font-size: 12px;
      margin: 5px 0;
    }
  }
}
</style>
